// extracted by mini-css-extract-plugin
export var actions = "_u8-4";
export var item = "_u8-1";
export var price = "_u8-3";
export var quantity = "_u8-2";
export var table = "_u8-0";